var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-cm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h170.667v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M170.667 0h170.667v512H170.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M341.333 0H512v512H341.333z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256) scale(5.6889)",
    fill: "#fcd116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0-8L-2.472-.392 1.332.845z"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    transform: "rotate(-72)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm);
export default __webpack_public_path__ + "static/media/cm.8ba1901dc25cb0a8a41b6061598ba0d6.svg";
export { ForwardRef as ReactComponent };